import { KeyValueObject, SystemEntity } from '../../models';
import {
    ADVISER_FORM_ID,
    CAMPAIGN_FORM_ID,
    DOCUMENT_FORM_ID,
    EVENT_FORM_ID,
    EVENT_PARTICIPATION_FORM_ID,
    INTERMEDIARY_FORM_ID,
    LETTER_FORM_ID,
    LIST_FORM_ID,
    OPPORTUNITY_FORM_ID,
    TASK_FORM_ID,
    USER_FORM_ID,
} from './form-ids.static';

export const ENTITY_FORM_ID_MAP: KeyValueObject<string> = {
    [SystemEntity.Adviser]: ADVISER_FORM_ID,
    [SystemEntity.Campaign]: CAMPAIGN_FORM_ID,
    [SystemEntity.Document]: DOCUMENT_FORM_ID,
    [SystemEntity.Event]: EVENT_FORM_ID,
    [SystemEntity.EventParticipation]: EVENT_PARTICIPATION_FORM_ID,
    [SystemEntity.Intermediary]: INTERMEDIARY_FORM_ID,
    [SystemEntity.Letter]: LETTER_FORM_ID,
    [SystemEntity.List]: LIST_FORM_ID,
    [SystemEntity.OpportunityTeamMember]: OPPORTUNITY_FORM_ID,
    [SystemEntity.Task]: TASK_FORM_ID,
    [SystemEntity.User]: USER_FORM_ID,
};
